import { FilterPlugin } from '@/utils/filters';
import Vue from 'vue';

Vue.use(FilterPlugin);
